module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap search-all-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "serarch-input",
    attrs: {
      "type": "text",
      "name": "",
      "placeholder": "搜索商品关键词"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "search-btn",
    on: {
      "click": function($event) {
        return _vm.searchGoods(_vm.searchKey)
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [(_vm.lastSearchList && _vm.lastSearchList.length) ? _c('div', {
    staticClass: "last-search"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "floatL"
  }, [_vm._v("最近搜索")]), _vm._v(" "), _c('span', {
    staticClass: "floatR button",
    on: {
      "click": function($event) {
        _vm.isDialog = true
      }
    }
  }, [_vm._v("清除")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-label"
  }, _vm._l((_vm.lastSearchList), function(item, index) {
    return _c('mu-flat-button', {
      key: index,
      staticClass: "label",
      attrs: {
        "label": item
      },
      on: {
        "click": function($event) {
          return _vm.searchGoods(item)
        }
      }
    })
  }), 1)]) : _vm._e(), _vm._v(" "), (_vm.searchKeywordList && _vm.searchKeywordList.length) ? _c('div', {
    staticClass: "hot-search"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('span', {
    staticClass: "floatL"
  }, [_vm._v("热门搜索")]), _vm._v(" "), _c('span', {
    staticClass: "floatR button",
    on: {
      "click": _vm.batchKeyword
    }
  }, [_vm._v("换一批")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-label"
  }, _vm._l((_vm.searchKeywordList), function(item, index) {
    return _c('mu-flat-button', {
      key: index,
      staticClass: "label",
      attrs: {
        "label": item
      },
      on: {
        "click": function($event) {
          return _vm.searchGoods(item)
        }
      }
    })
  }), 1)]) : _vm._e()]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.isDialog,
      "title": "提示"
    },
    on: {
      "close": function($event) {
        _vm.isDialog = false
      }
    }
  }, [_vm._v("\n\t    是否清空搜索内容\n\t    "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": function($event) {
        _vm.isDialog = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.clearSearch
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a8ba712","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/allSearch.vue
// module id = 380
// module chunks = 68